<h1 mat-dialog-title>{{data.isEdit ? '' : 'New'}} Datapoint</h1>
<div mat-dialog-content>
    <app-select-search label="Measure" [list]="measures" [model]="item.measure" (modelChanged)="item.measure = $event;" [isRequired]="true"></app-select-search>

    <mat-form-field class="w-100 mb-2">
        <mat-label>Period (int)</mat-label>
        <input matInput type="number" placeholder="Period" name="period" [(ngModel)]="item.period" required>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Bezár</button>
    <button mat-button color="primary" (click)="onSaveClick()" translate>SAVE</button>
</div>
